import { AIR_HELP, BAGGAGE_SERVICE, CABIN_BAGGAGE, CANCEL_FOR_ANY_REASON, CANCELLATION_GUARANTEE, CANCELLATION_INSIDE_EU, CANCELLATION_OUTSIDE_EU, CHECK_IN_BAGGAGE, CLIMATE_COMPENSATION, CONNECTION_GUARANTEE, FLEXIBLE_TICKET, MEAL, MOBILE_TRAVEL_PLAN, ONLINE_CHECK_IN, PLATINUM_SERVICE, SEAT_MAP, SECOND_BAGGAGE, SERVICE_PACKAGE_NO_TEXT, SERVICE_PACKAGE, SIMPLE_VISA, SMS, TRAVEL_INSURANCE_INSIDE_EU, TRAVEL_INSURANCE_OUTSIDE_EU } from '../../products';
import getAirHelpIcon from '../../air-help/utils/icon';
import getBaggageServiceIcon from '../../baggage-service/utils/icon';
import getCabinBaggageIcon from '../../baggage-section/cabin-baggage/utils/icon';
import getCancelForAnyReasonIcon from '../../cancel-for-any-reason/utils/icon';
import getCancellationIcon from '../utils/icon/cancelation-icon';
import getCheckInBaggageIcon from '../../baggage-section/check-in-baggage/utils/icon';
import getClimateCompensationIcon from '../../climate-compensation/utils/icon';
import getConnectionGuaranteeIcon from '../../connection-guarantee/utils/icon';
import getDefaultIcon from '../utils/icon/defaultProductIcon';
import getFlexibleTicketIcon from '../../flexible-ticket/utils/icon';
import getMealIcon from '../../meal/utils/icon';
import getMobileTravelPlanIcon from '../../mobile-travel-plan/utils/icon';
import getOnlineCheckInIcon from '../../online-check-in/utils/icon';
import getSeatingIcon from '../../seat-map/utils/icon';
import getServicePackageIcon from '../../service-package/utils/icon';
import getSimpleVisaIcon from '../../simple-visa/utils/icon';
import getSmsIcon from '../../sms/utils/icon';
import getTravelInsuranceIcon from '../../travel-insurance/common/utils/icon';
export default (id, type) => {
  // Each icon getter declares `type: IconType` as required, but the underlying
  // getIcon()/isNeutral() helpers already tolerate `undefined` fine — this
  // resolver has always been called with an optional type in practice.
  const iconType = type;
  switch (id) {
    case CANCEL_FOR_ANY_REASON.name:
      return getCancelForAnyReasonIcon(iconType);
    case AIR_HELP.name:
      return getAirHelpIcon(iconType);
    case BAGGAGE_SERVICE.name:
      return getBaggageServiceIcon(iconType);
    case CANCELLATION_GUARANTEE.name:
    case CANCELLATION_INSIDE_EU.name:
    case CANCELLATION_OUTSIDE_EU.name:
      return getCancellationIcon(iconType);
    case CHECK_IN_BAGGAGE.name:
      return getCheckInBaggageIcon(iconType);
    case SECOND_BAGGAGE.name:
      return getCheckInBaggageIcon(iconType);
    case CLIMATE_COMPENSATION.name:
      return getClimateCompensationIcon(iconType);
    case CONNECTION_GUARANTEE.name:
      return getConnectionGuaranteeIcon(iconType);
    case FLEXIBLE_TICKET.name:
      return getFlexibleTicketIcon(iconType);
    case MEAL.name:
      return getMealIcon(iconType);
    case MOBILE_TRAVEL_PLAN.name:
      return getMobileTravelPlanIcon(iconType);
    case ONLINE_CHECK_IN.name:
      return getOnlineCheckInIcon(iconType);
    case PLATINUM_SERVICE.name:
      return getServicePackageIcon(iconType);
    case SEAT_MAP.name:
      return getSeatingIcon(iconType);
    case SERVICE_PACKAGE.name:
    case SERVICE_PACKAGE_NO_TEXT.name:
      return getServicePackageIcon(iconType);
    case SMS.name:
      return getSmsIcon(iconType);
    case TRAVEL_INSURANCE_INSIDE_EU.name:
    case TRAVEL_INSURANCE_OUTSIDE_EU.name:
      return getTravelInsuranceIcon(iconType);
    case SIMPLE_VISA.name:
      return getSimpleVisaIcon(iconType);
    case CABIN_BAGGAGE.name:
      return getCabinBaggageIcon(iconType);
    default:
      return getDefaultIcon(iconType);
  }
};
//# sourceMappingURL=productIconResolver.js.map